import jsPDF from "jspdf";
import autoTable from "jspdf-autotable"; // Ensure this is correctly imported
import { storage } from "./firebase/firebase";
import logo from "./assets/logo.png";

export const COLORS = {
    primary: "#d68028",
  };
  
 
 
export const generatePDF = async (formData,allFormValues) => {
  return new Promise(async (resolve, reject) => {
      try {
          const doc = new jsPDF();
          const pageWidth = doc.internal.pageSize.width;
          const margin = 20;
          const maxWidth = pageWidth - margin * 2;
          
            // Replace with actual Base64 logo
          const logoWidth = 30;
          const logoHeight = 30;
          // Directly use the imported logo as it is already in Base64 format
          const logoY = 0; // Adjust vertical alignment for the logo
          const logoX = 13; // Center the logo horizontally
          doc.addImage(logo, "PNG", logoX, logoY, logoWidth, logoHeight);
      // Align logo and title in the same line
      const titleX = margin + logoWidth + 20; // Adjust title position based on logo width and spacing
      const titleY = 18; // Adjust vertical alignment
      doc.setFontSize(18);
      doc.text("Driver Registration", titleX, titleY);

      

          // Convert form data into table format
          const tableData = Object.entries(formData).map(([question, answer]) => {
              const textValue = String(answer);
              return [question, textValue.startsWith("http") ? "" : textValue];
          });

          autoTable(doc, {
              head: [["Question", "Response"]],
              body: tableData,
              startY: 25,
              styles: { fontSize: 10, cellWidth: "wrap" },
              headStyles: { fillColor: COLORS.primary, textColor: "#ffffff", fontStyle: "bold" },
              columnStyles: {
                  0: { cellWidth: 60 },
                  1: { cellWidth: maxWidth - 60 },
              },
              didDrawCell: function (data) {
                  if (data.column.index === 1) {
                      const text = String(formData[data.row.raw[0]]);
                      if (text.startsWith("http")) {
                          doc.setTextColor(0, 0, 255);
                          doc.textWithLink("Link", data.cell.x + 2, data.cell.y + 5, { url: text,maxWidth:maxWidth-60, });
                          doc.setTextColor(0, 0, 0);
                      }
                  }
              },
          });
          const pdfBlob = doc.output("blob");
          const pdfUrl = (await storage().ref().child(`${allFormValues.firstName}-${Date.now()}.pdf`).put(pdfBlob)).ref.getDownloadURL();

          resolve(pdfUrl); 

      } catch (error) {
          reject(error);
      }
  });
};
  


